const state = {
  selectedAudio: null,
  playing: false
}

const getters = {
  selected: state => state.selectedAudio,
  playing: state => state.playing
}

const actions = {
  setSelected ({ commit }, audio) {
    commit('setSelcted', audio)
  },
  setPlaying ({ commit }, playing) {
    commit('playing', playing)
  }
}

const mutations = {
  setSelcted (state, audio) {
    state.selectedAudio = audio
  },
  playing (state, playing) {
    state.playing = playing
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
